<div *ngIf="!busy">
    <div class="row margin-top-8">
        <div class="col-md-4 label">
            {{'bikeshop.text_message_integration.podium.location_title' | translate}}
        </div>
        <div class="col-md-8">
            <p-dropdown [options]="availableLocations" [(ngModel)]="selectedLocation" optionLabel="name"
              placeholder="{{'bikeshop.text_message_integration.podium.location_placeholder' | translate}}" [showClear]="true">
            </p-dropdown>
        </div>
    </div>

    <div class="row margin-top-8">
        <div class="col-md-4 label">
        </div>
        <div class="col-md-8">
             <button pButton *ngIf="currentData != null" (click)="update()" class="p-button-raised accent centered-button"
                    [disabled]="isValid() || updating">
                {{'bikeshop.text_message_integration.podium.update_button' | translate}}
            </button>
        </div>
    </div>

</div>